import { useState } from "react";
import { Box, Card, Container, useTheme } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { useStrategyStore } from "../../hooks/useStrategyStore";
import StoreHeader from "./components/StoreHeader";
import StrategySearchBar from "./components/StrategySearchBar";
import TimePeriodToggle from "./components/TimePeriodToggle";
import StrategyGrid from "./components/StrategyGrid";

const Store = () => {
  const theme = useTheme();
  const [cartCount, setCartCount] = useState(0);

  const {
    loading,
    timePeriod,
    searchTerm,
    setSearchTerm,
    filteredStrategies,
    handleTimePeriodChange,
    pagination,
    currentPage,
    handlePageChange,
  } = useStrategyStore();

  const handleAddToCart = ({ strategyID }) => {
    console.log(`Adding strategy ${strategyID} to cart`);
    setCartCount((prev) => prev + 1);
  };

  const handleCartClick = () => {
    console.log("Opening cart");
  };

  return (
    <>
      <Helmet>
        <title>Store | Vantage Alpha</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: theme.palette.mode === "dark" ? theme.palette.grey[50] : "#ebebeb",
          background: theme.palette.mode === "dark" ? theme.palette.grey[50] : "#ebebeb",
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <StoreHeader cartCount={cartCount} onCartClick={handleCartClick} />
          <StrategySearchBar value={searchTerm} onChange={setSearchTerm} />
          <TimePeriodToggle
            value={timePeriod}
            onChange={handleTimePeriodChange}
          />
          <Card
            sx={{
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              border: `1px solid ${theme.palette.divider}`,
              p: 2,
              position: "relative"
            }}
          >

            <StrategyGrid
              strategies={filteredStrategies}
              loading={loading}
              onAddToCart={handleAddToCart}
              searchTerm={searchTerm}
              pagination={pagination}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />

          </Card>
        </Container>
      </Box>
    </>
  );
};

export default Store;
